import { Input, Select } from 'antd';
import classnames from 'classnames';
import _ from 'lodash';
import { get } from 'lodash-es';
import React, { FC } from 'react';
import { RecordType } from '@/presentation/pages/setting/app-deliver-config/components/configuration-content';
import { DiffCustomizeData } from '@/presentation/pages/setting/app-deliver-config/config-modal/edit/diff-customize-data';
import { DiffType } from '@/presentation/pages/setting/app-deliver-config/config-modal/edit/diff-modal';
import styles from '@/presentation/pages/setting/app-deliver-config/config-modal/edit/diff.module.scss';
import { TYPE } from '@/presentation/pages/setting/app-deliver-config/utils';
import { useStores } from '@/presentation/store';

interface IProps {
  config: RecordType; // 当前的配置项，包含默认配置项和全量配置项
  fullConfig: RecordType; // 全量配置项
  dataSource: RecordType; // 原始数据
  options?: { label: string, value: string }[];
  diffConfig: RecordType // 对比配置
  diffType: DiffType
}


export const DiffRenderSubConfigItem: FC<IProps> = (props: IProps) => {
  const { config, options, fullConfig, diffConfig, diffType } = props;
  const isPrev = diffType === DiffType.PREV;
  const { configs: operation = {} } = useStores().ConfigStore;
  const { configFieldInfo = {} } = operation;

  return <div className={styles.subConfigItem}>
    {Object.keys(config).map((item) => {
      const value = typeof config[item] === 'object' ? JSON.stringify(config[item]) : config[item];
      const subConfigItemType = get(configFieldInfo, `${item}.type`, TYPE.UNKNOWN);
      const valueEqual = !_.isEqual(value, diffConfig[item]);
      if (['array', 'object array', 'string array'].includes(subConfigItemType)) {
        return <DiffCustomizeData
          config={{ [item]: { [item]: config[item] } } || {}}
          typeDisabled={true}
          diffConfig={diffConfig[item] ? { [item]: { [item]: diffConfig[item] } } : {}}
          fatherNameOption={options ?? []}
          fatherNameValue={item}
          diffType={diffType}
          childName={subConfigItemType === 'object array' ? fullConfig?.[item]?.[0] : undefined}
        />;
      }
      return  <div className={styles.jsonItem}>
        <div title={item} className={classnames({
          [styles.diffPrev]: isPrev && diffConfig[item] === undefined,
          [styles.diffNext]: !isPrev && diffConfig[item] === undefined,
          [styles.customizeName]: true,
        })}>
          <Select
            options={options ?? []}
            disabled={true}
            showArrow={false}
            value={item}
          />
        </div>
          <div title={subConfigItemType} className={classnames({
            [styles.diffPrev]: isPrev && diffConfig[item] === undefined,
            [styles.diffNext]: !isPrev && diffConfig[item] === undefined,
            [styles.customizeType]: true,
          })}>
            <Input
              disabled={true}
              value={subConfigItemType}
            />
          </div>
        <div title={value} className={classnames({
          [styles.diffPrev]: isPrev && valueEqual,
          [styles.diffNext]: !isPrev && valueEqual,
          [styles.customizeValue]: true,
        })}>
          <Input
            disabled={true}
            value={value}
          />
        </div>
        </div>;
    })}
  </div>;
};
